export const navs = [
  { id: 1, title: 'all', isActive: false },
  { id: 2, title: 'ring', isActive: false },
  { id: 3, title: 'necklace', isActive: false },
  { id: 4, title: 'earing', isActive: false },
  { id: 5, title: 'bracelet', isActive: false }
];
